define('app/views/add_to_cart_form_view',['app/setup'], function(takhfifan) {

  takhfifan.AddToCartFormView = takhfifan.BaseView.extend({

    initialize: function(options) {
      var _this = this;
      var productId = options.productId;

      var $input = $('<input />').prop({
        type: 'hidden',
        name: 'product'
      }).val(productId);

      this.$el.append($input);

      takhfifan.eventHub.on('cartinfo:' + productId, function(info) {
        _this.cartInfo(info, productId);
      });

      takhfifan.eventHub.on('productoptions:' + productId, function(opts) {
        _this.productOptions(opts);
      });

      takhfifan.eventHub.on('productaddtocart:' + productId, function(opts) {
        var productData = {};
        if(_this.productInfo.price){
          productData["price"] = _this.productInfo.price;
        }
        if(opts && !opts.parentProductId){
          _this.productType = "simple";
        }else{
          _this.productType = "grouped";
          productData["variant"] = opts.parentProductId;
        }

        takhfifan.eventHub.trigger('ga:addToCart', productData);
        setTimeout(_this.submit(opts), 2000);
        takhfifan.eventHub.trigger('ga:sendPageView', {
          title: "buy button",
          path: _this.getVirtualUrl(),
          callback: _this.submit(opts)
        });
      });
      takhfifan.eventHub.on('productaddtocart:configurable', function(opts) {
        _this.productType = "configurable";
        _this.productId=opts.productId;
        _this.$el.prop('action', _this.addToCartUrl(opts.productId));
        _this.$('[name="product"]').val(_this.productId);

        takhfifan.eventHub.trigger('ga:addToCart', {"variant": _this.productId, "price": _this.productInfo.price || 0});
        setTimeout(_this.submit(opts), 2000);
        takhfifan.eventHub.trigger('ga:sendPageView', {
          title: "buy button",
          path: _this.getVirtualUrl(),
          callback: _this.submit(opts)
        });
      });

      takhfifan.eventHub.on('giftmessage:enableGift', function(opts) {
        if(_.isUndefined(opts.checkBeforeSubmit)){
          opts.checkBeforeSubmit = false;
        }
        _this.enableGift(opts);
      });
    },

    enableGift: function(opts) {
      takhfifan.giftEnabled = true;

      $.get(opts.giftEnableUrl, function(response) {
        if(!_.isUndefined(opts.productToAdd)) {
          if(opts.checkBeforeSubmit){
            takhfifan.eventHub.trigger('configurableProduct:addToCartCheck', opts.objectToPass);
          }else{
            takhfifan.eventHub.trigger('productaddtocart:' + opts.productToAdd, opts);
          }
        }
      });
    },

    cartInfo: function(info, productId) {
      this.$('input [name="form_key"]').remove();
      this.productInfo = info.attributes;

      var $input = $('<input />').prop({
        type: 'hidden',
        name: 'form_key'
      }).val(info.get('formKey'));

      this.$el.append($input);
      this.productId =productId;
      this.$el.prop('action', this.addToCartUrl(this.productId));
    },

    productOptions: function(options) {
      var _this = this;
      var choices = options.get('choices');

      _.each(choices, function(choice, sa){
        var selector = 'input[name="super_attribute[' + sa + ']"]';
        _this.$(selector).remove();

        if (choice != null && typeof choice != undefined) {
          var $input = $('<input />').prop({
            type: 'hidden',
            name: 'super_attribute[' + sa + ']'
          }).val(choice);
          _this.$el.append($input);
        }
      });
    },

    getVirtualUrl: function () {
      var virtualViewUrl = "/#buy/" + this.productType;

      if(takhfifan.giftEnabled){
        virtualViewUrl += "/gift";
      }else {
        virtualViewUrl += "/normal";
      }
      return virtualViewUrl
    },

    submit: _.once(function() {
      this.setResetSessionFlag();
      this.$el.submit();
    })

  });

});

